import { Component, OnDestroy } from '@angular/core';
// this component is used in combination with AngularjsGuard to allow angular to know about
// angularjs pages and prevent navigation when pages are dirty
// remove when all angularjs detailspages are totally migrated

@Component({
	selector: 'bb-empty',
	template: ``,

})
export class BbEmptyComponent implements OnDestroy {

	constructor() {
		document.querySelector('bb-ovp6 #content').classList.add('hidden');
	}

	ngOnDestroy() {
		document.querySelector('bb-ovp6 #content').classList.remove('hidden');
	}
}
